import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';

export const search = async (payload) => {
  const values = { ...payload };
  if (values?.from) {
    _.set(values, 'from', moment(values?.from).format('DD/MM/YYYY'));
  }
  if (values?.to) {
    _.set(values, 'to', moment(values?.to).format('DD/MM/YYYY'));
  }
  return axios.post(`/api/report`, values).then((res) => res.data.content);
};